export const SEQUENCE_CATEGORIES = {
  "Narrative Structure": [
    ["narrativeShape", "Narrative Shape"],
    ["plotProgression", "Plot Progression"],
    ["escalation", "Escalation"],
    ["revealRhythm", "Reveal Rhythm"],
    ["subplotIntegration", "Subplot Integration"]
  ],
  "Character & Goals": [
    ["characterLeveragePoint", "Character Leverage Point"],
    ["internalGoalProgress", "Internal Goal Progress"],
    ["externalGoalProgress", "External Goal Progress"]
  ],
  "Engagement & Flow": [
    ["compelledToKeepReading", "Compelled To Keep Reading"],
    ["emotionalImpact", "Emotional Impact"],
    ["pacing", "Pacing"],
    ["impact", "Impact"],
    ["memorability", "Memorability"]
  ],
  "Voice & Style": [
    ["tonalVisualCohesion", "Tonal Visual Cohesion"],
    ["originality", "Originality"]
  ],
  "Technical": [
    ["readability", "Readability"]
  ]
};

export const SCENE_CATEGORIES = {
    'Overall': [['rating', 'Overall']],
    'Story Content': [
      ['conceptrating', 'Concept'],
      ['plotrating', 'Plot'],
      ['originality_score', 'Originality']
    ],
    'Character Development': [
      ['charactersrating', 'Characters'],
      ['characterchanges', 'Character Changes'],
      ['internal_goal_score', 'Internal Goal'],
      ['external_goal_score', 'External Goal']
    ],
    'Scene Elements': [
      ['conflict_level', 'Conflict Level'],
      ['opposition_score', 'Opposition'],
      ['highstakes', 'High Stakes'],
      ['storyforward', 'Story Forward'],
      ['unpredictability_score', 'Unpredictability'],
      ['philosophical_conflict_score', 'Philosophical Conflict']
    ],
    'Audience Engagement': [
      ['emotional_impact', 'Emotional Impact'],
      ['dialoguerating', 'Dialogue'],
      ['engagement_score', 'Engagement'],
      ['pacing_score', 'Pacing'],
      ['compelledToKeepReading', 'Compelled to Keep Reading']
    ],
    'Technical Aspect': [
      ['formatting_score', 'Formatting'],
      ['structure_score', 'Structure']
    ]
  };
  
  export const ACT_CATEGORIES = {
    "Narrative Structure": [
      ["plotProgression", "Plot Progression"],
      ["narrativeShape", "Narrative Shape"],
      ["revealRhythm", "Reveal Rhythm"],
      ["stakesHandling", "Stakes Handling"],
      ["escalation", "Escalation"]
    ],
    "Character & Thematic Arcs": [
      ["character", "Character Development"],
      ["internalGoalProgress", "Internal Goal Progress"],
      ["externalGoalProgress", "External Goal Progress"],
      ["theme_resonance_execution", "Theme Resonance"],
      ["characterArcContribution", "Character Arc Contribution"],
      ["thematicAlignment", "Thematic Alignment"],
      ["genreConsistency", "Genre Consistency"],
      ["subplotIntegration", "Subplot Integration"]
    ],
    "Emotional & Engagement": [
      ["emotionalImpact", "Emotional Impact"],
      ["compelledToKeepReading", "Compelled To Keep Reading"],
      ["tonalVisualCohesion", "Tonal & Visual Cohesion"],
      ["impact", "Overall Impact"],
      ["memorability", "Memorability"],
    ["originality", "Originality"] // ADD THIS LINE
    ],
    "Technical & Readability": [
      ["readability", "Readability"],
      ["pacing", "Pacing"]
    ]
  };

// NEW: Reverse mapping to find which category contains each metric
export const METRIC_TO_CATEGORY = {
  // Act metrics
  pacing: "Technical & Readability",
  emotionalImpact: "Emotional & Engagement", 
  originality: "Voice & Style",
  stakesHandling: "Narrative Structure",
  character: "Character & Thematic Arcs",
  
  // Sequence metrics  
  narrativeShape: "Narrative Structure",
  plotProgression: "Narrative Structure",
  escalation: "Narrative Structure",
  revealRhythm: "Narrative Structure",
  subplotIntegration: "Narrative Structure",
  characterLeveragePoint: "Character & Goals",
  internalGoalProgress: "Character & Goals",
  externalGoalProgress: "Character & Goals",
  compelledToKeepReading: "Engagement & Flow",
  impact: "Engagement & Flow",
  memorability: "Engagement & Flow",
  tonalVisualCohesion: "Voice & Style",
  readability: "Technical",
  
  // Scene metrics
  conceptrating: "Story Content",
  plotrating: "Story Content", 
  originality_score: "Story Content",
  charactersrating: "Character Development",
  characterchanges: "Character Development",
  internal_goal_score: "Character Development", 
  external_goal_score: "Character Development",
  conflict_level: "Scene Elements",
  opposition_score: "Scene Elements",
  highstakes: "Scene Elements",
  storyforward: "Scene Elements",
  unpredictability_score: "Scene Elements",
  philosophical_conflict_score: "Scene Elements",
  emotional_impact: "Audience Engagement",
  dialoguerating: "Audience Engagement",
  engagement_score: "Audience Engagement",
  pacing_score: "Audience Engagement",
  formatting_score: "Technical Aspect",
  structure_score: "Technical Aspect"
};